<div class="flex flex-row">
    @for (role of approvalFlow; track role.status;) {
        <approval-flow-chip
            [status]="role.status"
            [label]="role.roleCode"/>
    }
    @empty {
        <p class="m-0">FEC no enviada</p>
    }
</div>